var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"k-item k-state-default",on:{"click":function($event){return _vm.item.action()}}},[_c('span',{staticClass:"k-link"},[_vm._v(_vm._s(_vm.item.text))]),_vm._v(" "),_c('ul',_vm._l((_vm.item.children),function(value,key,index){return _c('contextMenuItem',{key:key,attrs:{"item":value}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }